import { t } from "@lingui/macro";
import React from "react";
import InformationPill from "~/applications/OfferSearch/Ui/OfferDetails/InformationPill";
import { Breakfast } from "~/guidelines/Icon";
import ListItemWithIcon from "~/guidelines/ListItemWithIcon";

export type BreakfastAmenityProps = {
  variant?: "list-item" | "pill";
};

const BreakfastAmenity = ({ variant = "list-item" }: BreakfastAmenityProps) => {
  const textChildren = t`Breakfast`;

  if (variant === "pill") {
    return <InformationPill icon={<Breakfast />} text={textChildren} />;
  }

  return (
    <ListItemWithIcon icon={<Breakfast />}>{textChildren}</ListItemWithIcon>
  );
};

export default BreakfastAmenity;
